<template>
    <v-row>
        <v-col cols="11">
            <v-textarea
                :label="$t('formFields.generalNotes')"
                :model-value="modelValue"
                @update:model-value="$emit('update:modelValue', $event)"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {modelValue: String},
    emits: ['update:modelValue'],
};
</script>
